module.exports = __webpack_public_path__ + "img/PAYPAL_EXPRESS_CHECKOUT.ab9b8ef5.svg";